import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_SECRET,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  debug: true, // Enable debug mode
  // Add more configuration options
  environment: "development",
  tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
});

console.log("Sentry initialized:", Sentry.getCurrentHub().getClient() !== undefined);

createRoot(document.getElementById("root")!).render(<App />);
